import MissionContainer from '../components/MissionContainer';
import '../stylesheets/Mission.css';

const Missions = () => (
  <div>
    <MissionContainer />
  </div>
);

export default Missions;
